import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import type { ButtonProps as BsButtonProps } from "react-bootstrap";
import { Button as BsButton } from "react-bootstrap";

export interface ButtonProps extends BsButtonProps {
	download?: boolean;
	icon?: ReactNode;
	outlined?: boolean;
	rounded?: boolean;
	rel?: string;
	iconPosition?: "start" | "end";
}

export const Button = React.forwardRef<HTMLElement, ButtonProps>(
	({ className, variant = "primary", icon, children, rounded, outlined, iconPosition = "start", ...props }, ref) => {
		const iconOnly = !children && !!icon;
		const classes = compact([
			className,
			iconOnly && "btn-icon-only",
			iconOnly && (props.size === "sm" ? "px-2" : `px-3`),
			rounded && "rounded-circle",
		]).join(" ");
		const variantAlias = outlined ? `outline-${variant}` : variant;

		return (
			<BsButton {...props} ref={ref} className={classes} variant={variantAlias}>
				{icon && iconPosition === "start" && (
					<span className={`btn-fa-icon${iconOnly ? "" : " mr-2"}`}>{icon}</span>
				)}
				{children}
				{icon && iconPosition === "end" && (
					<span className={`btn-fa-icon${iconOnly ? "" : " ml-2"}`}>{icon}</span>
				)}
			</BsButton>
		);
	},
);
